<template>
    <div v-if="showShareOptions" class="social-icons">
        <a :href="shareLinks.email" target="_blank" title="Email" v-html="icons.email"></a>
        <a :href="shareLinks.facebook" target="_blank" title="Facebook" v-html="icons.facebook"></a>
        <a :href="shareLinks.twitter" target="_blank" title="Twitter" v-html="icons.twitter"></a>
        <a :href="shareLinks.linkedin" target="_blank" title="LinkedIn" v-html="icons.linkedin"></a>
    </div>
    <ion-toolbar class="job-detail-toolbar">
        <ion-buttons slot="start">
            <ion-button class="button_back" data-testid="directions-87" @click="goBack()">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Job Details</ion-title>
        <ion-buttons slot="end" class="toolbar-end-buttons" v-if="!jobUnavailable && job">
            <ion-button @click="markFavorite(job)">
                <!-- <el-tooltip :content="job.favorite ? 'Remove from favorite' : 'Mark as favorite'" placement="top"> -->
                <div class="favorite" :class="{ selected: job.favorite }">

                    <svg width="20" height="20" viewBox="0 0 20 20" fill="#B3B6BE" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.0166 1.6665H5.98327C4.20827 1.6665 2.7666 3.1165 2.7666 4.88317V16.6248C2.7666 18.1248 3.8416 18.7582 5.15827 18.0332L9.22493 15.7748C9.65827 15.5332 10.3583 15.5332 10.7833 15.7748L14.8499 18.0332C16.1666 18.7665 17.2416 18.1332 17.2416 16.6248V4.88317C17.2333 3.1165 15.7916 1.6665 14.0166 1.6665ZM12.0833 9.49984H7.9166C7.57494 9.49984 7.2916 9.2165 7.2916 8.87484C7.2916 8.53317 7.57494 8.24984 7.9166 8.24984H12.0833C12.4249 8.24984 12.7083 8.53317 12.7083 8.87484C12.7083 9.2165 12.4249 9.49984 12.0833 9.49984Z"
                            fill="#B3B6BE" />
                    </svg>
                </div>
                <!-- </el-tooltip> -->
            </ion-button>
            <ion-button class="button_more" @click="toggleShareOptions" data-testid="share-pharmacy-btn">
                <i class="el-icon-share"></i>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
    <div class="main_wrapper ion-padding">

        <div v-if="jobUnavailable && !initialLoading" class="job-unavailable-state">
            <p class="job-unavailable-message">The job ad is not available anymore</p>
            <el-button type="primary" @click="goBack()">Back to home</el-button>
        </div>

        <div class="job-detail-wrapper" v-if="job !== null && initialLoading === false && !jobUnavailable">

            <div class="container">
                <div class="job-detail-header">
                    <div class="image_wrapper" data-testid="directions-64" @click="userInfoModalOpen(job.pharmacy)">
                        <el-avatar :size="'small'" shape="square" :src="job.pharmacy.image" v-if="job.pharmacy.image" />
                        <el-avatar :size="'small'" class="avatar-job" shape="square"
                            icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
                    </div>
                    <div class="job-detail-header-row">
                        <div class="job-detail-header-row-left">
                            <div class="job-title">{{ job.title }}</div>
                            <div class="job-poster">{{ job.pharmacy.name }}</div>
                        </div>
                        <el-tag class="inverted">
                            Published {{ job.publishedDate }}
                        </el-tag>
                    </div>

                    <div class="preview-section">
                        <div class="preview-section__header">
                            <div class="preview-section__title">
                                Job Details
                            </div>
                        </div>

                        <p v-html="displayedText" class="job-description"></p>
                        <el-button class="text-only" @click="toggleView" v-if="isShowMoreJD">
                            {{ state.isTruncated ? 'View More' : 'View Less' }}
                        </el-button>
                    </div>

                    <div class="separator"></div>
                    <div class="preview-section">

                        <div class="detail-item">
                            <div class="detail-item__icon">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M18.3332 9.99984C18.3332 14.5998 14.5998 18.3332 9.99984 18.3332C5.39984 18.3332 1.6665 14.5998 1.6665 9.99984C1.6665 5.39984 5.39984 1.6665 9.99984 1.6665C14.5998 1.6665 18.3332 5.39984 18.3332 9.99984Z"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M13.0919 12.65L10.5086 11.1083C10.0586 10.8416 9.69189 10.2 9.69189 9.67497V6.2583"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </div>
                            <div class="detail-item__value">{{ job.type }}</div>
                        </div>
                        <div class="detail-item" v-if="!job.hideSalary">
                            <div class="detail-item__icon">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.22656 11.9417C7.22656 13.0167 8.05156 13.8834 9.07656 13.8834H11.1682C12.0599 13.8834 12.7849 13.125 12.7849 12.1917C12.7849 11.175 12.3432 10.8167 11.6849 10.5834L8.32656 9.4167C7.66823 9.18337 7.22656 8.82503 7.22656 7.80837C7.22656 6.87503 7.95156 6.1167 8.84323 6.1167H10.9349C11.9599 6.1167 12.7849 6.98337 12.7849 8.05837"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 5V15" stroke="rgb(var(--locumate-primary-color-dark))"
                                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M9.99984 18.3332C14.6022 18.3332 18.3332 14.6022 18.3332 9.99984C18.3332 5.39746 14.6022 1.6665 9.99984 1.6665C5.39746 1.6665 1.6665 5.39746 1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332Z"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>


                            </div>
                            <div class="detail-item__value">{{ job.payInterval }} Rate:{{ job.payRate }}</div>
                        </div>
                        <div class="detail-item">
                            <div class="detail-item__icon">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.9999 11.1917C11.4358 11.1917 12.5999 10.0276 12.5999 8.5917C12.5999 7.15576 11.4358 5.9917 9.9999 5.9917C8.56396 5.9917 7.3999 7.15576 7.3999 8.5917C7.3999 10.0276 8.56396 11.1917 9.9999 11.1917Z"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" />
                                    <path
                                        d="M3.01675 7.07484C4.65842 -0.141827 15.3501 -0.133494 16.9834 7.08317C17.9418 11.3165 15.3084 14.8998 13.0001 17.1165C11.3251 18.7332 8.67508 18.7332 6.99175 17.1165C4.69175 14.8998 2.05842 11.3082 3.01675 7.07484Z"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" />
                                </svg>

                            </div>
                            <div class="detail-item__value">{{ job.category }}</div>
                        </div>
                        <div class="detail-item" v-if="isUS && job.federalPharmacistSupport === 1">
                            <div class="detail-item__icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.15002 2V22" stroke="rgb(var(--locumate-primary-color-dark))"
                                        stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M5.15002 4H16.35C19.05 4 19.65 5.5 17.75 7.4L16.55 8.6C15.75 9.4 15.75 10.7 16.55 11.4L17.75 12.6C19.65 14.5 18.95 16 16.35 16H5.15002"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>


                            </div>
                            <div class="detail-item__value" v-if="job.federalPharmacistSupport === 1">Federal Pharmacist
                                Support</div>
                        </div>
                    </div>



                    <div class="separator" v-if="job.selectedJobPostSkills.length > 0"></div>
                    <div class="preview-section" v-if="job.selectedJobPostSkills.length > 0">
                        <div class="preview-section__header">
                            <div class="preview-section__title">
                                Skills
                            </div>
                        </div>

                        <div class="skill-list-pills">
                            <div v-for="skill in job.selectedJobPostSkills" :key="skill.id">
                                <el-tag class="inverted pill">{{ skill.name }}</el-tag>
                            </div>
                        </div>
                    </div>

                    <div class="separator" v-if="job?.pharmacy?.scripts.length > 0"></div>
                    <div class="preview-section" v-if="job?.pharmacy?.scripts.length > 0">
                        <div class="preview-section__header">
                            <div class="preview-section__title">
                                Other Details
                            </div>
                        </div>

                        <div v-if="job.pharmacy.scripts.length > 0" class="job-scripts">
                            <div class="detail-item" v-for="(item, key) in job.pharmacy.scripts" :key="key">
                                <div class="detail-item__icon">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.6665 10.1665H12.4998"
                                            stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M6.6665 13.5H10.3165" stroke="rgb(var(--locumate-primary-color-dark))"
                                            stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M8.33317 4.99984H11.6665C13.3332 4.99984 13.3332 4.1665 13.3332 3.33317C13.3332 1.6665 12.4998 1.6665 11.6665 1.6665H8.33317C7.49984 1.6665 6.6665 1.6665 6.6665 3.33317C6.6665 4.99984 7.49984 4.99984 8.33317 4.99984Z"
                                            stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M13.3333 3.3501C16.1083 3.5001 17.5 4.5251 17.5 8.33343V13.3334C17.5 16.6668 16.6667 18.3334 12.5 18.3334H7.5C3.33333 18.3334 2.5 16.6668 2.5 13.3334V8.33343C2.5 4.53343 3.89167 3.5001 6.66667 3.3501"
                                            stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                </div>
                                <div class="detail-item__content">
                                    <div class="detail-item__topic">
                                        Average script per day {{ key === 'weekdays' ? '(' + key + ')' : key }}
                                    </div>
                                    <div class="detail-item__value">{{ item }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="detail-item">
                            <div class="detail-item__icon">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6.66685 18.3333H13.3335C16.6835 18.3333 17.2835 16.9917 17.4585 15.3583L18.0835 8.69167C18.3085 6.65833 17.7252 5 14.1668 5H5.83351C2.27518 5 1.69185 6.65833 1.91685 8.69167L2.54185 15.3583C2.71685 16.9917 3.31685 18.3333 6.66685 18.3333Z"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M6.6665 4.99984V4.33317C6.6665 2.85817 6.6665 1.6665 9.33317 1.6665H10.6665C13.3332 1.6665 13.3332 2.85817 13.3332 4.33317V4.99984"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M11.6668 10.8333V11.6667C11.6668 11.675 11.6668 11.675 11.6668 11.6833C11.6668 12.5917 11.6585 13.3333 10.0002 13.3333C8.35016 13.3333 8.3335 12.6 8.3335 11.6917V10.8333C8.3335 10 8.3335 10 9.16683 10H10.8335C11.6668 10 11.6668 10 11.6668 10.8333Z"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M18.0415 9.1665C16.1165 10.5665 13.9165 11.3998 11.6665 11.6832"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M2.18311 9.3916C4.05811 10.6749 6.17477 11.4499 8.33311 11.6916"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </div>
                            <div class="detail-item__content">
                                <div class="detail-item__topic">
                                    Dispensing Software
                                </div>
                                <div class="detail-item__value">
                                    {{ job.pharmacy.software }}<span v-if="job.pharmacy.software === 'Other'">: {{
                                        job.pharmacy.softwareOther }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="job.pharmacy.services.length > 0">
                        <div class="separator"></div>
                        <div class="preview-section">
                            <div class="preview-section__header">
                                <div class="preview-section__title">
                                    Services
                                </div>
                            </div>
                            <div class="detail-item" v-for="(item, key) in job.pharmacy.services" :key="key">
                                <div class="detail-item__icon">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.49984 18.3332H12.4998C16.6665 18.3332 18.3332 16.6665 18.3332 12.4998V7.49984C18.3332 3.33317 16.6665 1.6665 12.4998 1.6665H7.49984C3.33317 1.6665 1.6665 3.33317 1.6665 7.49984V12.4998C1.6665 16.6665 3.33317 18.3332 7.49984 18.3332Z"
                                            stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M6.4585 9.99993L8.81683 12.3583L13.5418 7.6416"
                                            stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                </div>
                                <div class="detail-item__value">{{ item }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="preview-section" v-if="jobQuestions.length > 0">
                        <div class="separator"></div>
                        <div class="preview-section__header">
                            <div class="preview-section__title">
                                Questions
                            </div>
                        </div>
                        <div class="preview-section__content">
                            <el-form class="full_page" :model="formData" ref="userForm" label-position="top">
                                <div v-for="question in jobQuestions" :key="question.id" class="questions-form">
                                    <label class="form-question">{{ question.question }}</label>
                                    <template v-if="question.type === 'text'">
                                        <el-input v-model="formData.questions[question.id].answer"
                                            :type="question.type"></el-input>
                                    </template>
                                    <template v-else-if="question.type === 'checkbox'">
                                        <el-checkbox-group v-model="formData.questions[question.id].answer">
                                            <el-checkbox v-for="(option, index) in question.options" :key="index"
                                                :label="option">{{
                                                option }}</el-checkbox>
                                        </el-checkbox-group>
                                    </template>
                                    <template v-else-if="question.type === 'radio'">
                                        <el-radio-group v-model="formData.questions[question.id].answer">
                                            <el-radio v-for="(option, index) in question.options" :key="index"
                                                :label="option">{{
                                                option }}</el-radio>
                                        </el-radio-group>
                                    </template>
                                    <template v-else-if="question.type === 'select'">
                                        <el-select v-model="formData.questions[question.id].answer"
                                            placeholder="Select an option">
                                            <el-option v-for="(option, index) in question.options" :key="index"
                                                :label="option" :value="option"></el-option>
                                        </el-select>
                                    </template>
                                    <template v-else-if="question.type === 'file'">
                                        <el-upload class="uploader-support" :action="'upload'" list-type="picture"
                                            :thumbnail-mode="true" :limit="1"
                                            :on-preview="(question, file) => cropperMethods.handlePreview(question, file)"
                                            :on-exceed="(question, file, files) => cropperMethods.handleExceed(question, file, files)"
                                            :drag="true"
                                            :on-change="(file, fileList) => cropperMethods.handleChange(question, file, fileList)"
                                            :before-upload="(question, file) => cropperMethods.beforeAvatarUpload(question, file)">
                                            <svg width="54" height="54" viewBox="0 0 54 54" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M27 4.5V18L31.5 13.5" stroke="black" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M27 18L22.5 13.5" stroke="black" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <path
                                                    d="M15.75 27C6.75 27 6.75 31.0275 6.75 36V38.25C6.75 44.46 6.75 49.5 18 49.5H36C45 49.5 47.25 44.46 47.25 38.25V36C47.25 31.0275 47.25 27 38.25 27C36 27 35.37 27.4725 34.2 28.35L31.905 30.78C29.25 33.615 24.75 33.615 22.0725 30.78L19.8 28.35C18.63 27.4725 18 27 15.75 27Z"
                                                    stroke="black" stroke-width="2" stroke-miterlimit="10"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M11.25 26.9998V17.9998C11.25 13.4773 11.25 9.74234 18 9.08984"
                                                    stroke="black" stroke-width="2" stroke-miterlimit="10"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M42.75 26.9998V17.9998C42.75 13.4773 42.75 9.74234 36 9.08984"
                                                    stroke="black" stroke-width="2" stroke-miterlimit="10"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                            <div class="cv-upload-title">Browse Your Files</div>
                                            <div class="cv-upload-info">You can only upload file with JPG JPEG PNG JFIF
                                                SVG or PDF formats and
                                                also file
                                                maximum size 10MB.</div>
                                            <template #file="{ file }">
                                                <div class="wrap-fd"
                                                    style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                                                    <div v-if="file.raw.type == 'application/pdf'"
                                                        class="el-upload-list__item-body">
                                                        <!-- <span class="locumate_icons locumate_icon-picture"></span> -->

                                                        <img class="el-upload-list__item-body-thumbnail"
                                                            :src="require('@/assets/img/icons/pdf.svg')" />
                                                        <span class="mx-2" size="large">{{ file.name }}</span>
                                                    </div>
                                                    <div class="el-upload-list__item-body" v-else>
                                                        <img class="el-upload-list__item-thumbnail" :src="file.url"
                                                            alt="" />
                                                        <span class="mx-2" size="large">{{ file.name }}</span>
                                                    </div>
                                                    <!-- Remove Button -->
                                                    <div class="el-upload-list__item-actions">
                                                        <button class="el-upload-list__item-actions-action"
                                                            @click.prevent="cropperMethods.handleRemove(question, file)">
                                                            <img :src="require('@/assets/img/icons/trash.svg')" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </template>
                                        </el-upload>
                                    </template>

                                    <el-form-item-error v-if="v$.questions.$invalid">{{
                                        v$['questions'][question.id]['answer'].required.$invalid ?
                                        v$['questions'][question.id]['answer'].required.$message : ""
                                        }}</el-form-item-error>
                                </div>
                            </el-form>
                        </div>

                    </div>
                    <div class="separator"></div>
                    <div class="preview-section">
                        <div class="preview-section__header">
                            <div class="preview-section__title">
                                Upload your CV
                            </div>
                        </div>
                        <div class="preview-section__content">
                            <div class="choose-cv">
                                <div class="cv-upload" @click="openCvDialog">
                                    <svg width="54" height="54" viewBox="0 0 54 54" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M27 4.5V18L31.5 13.5" stroke="black" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M27 18L22.5 13.5" stroke="black" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M15.75 27C6.75 27 6.75 31.0275 6.75 36V38.25C6.75 44.46 6.75 49.5 18 49.5H36C45 49.5 47.25 44.46 47.25 38.25V36C47.25 31.0275 47.25 27 38.25 27C36 27 35.37 27.4725 34.2 28.35L31.905 30.78C29.25 33.615 24.75 33.615 22.0725 30.78L19.8 28.35C18.63 27.4725 18 27 15.75 27Z"
                                            stroke="black" stroke-width="2" stroke-miterlimit="10"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M11.25 26.9998V17.9998C11.25 13.4773 11.25 9.74234 18 9.08984"
                                            stroke="black" stroke-width="2" stroke-miterlimit="10"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M42.75 26.9998V17.9998C42.75 13.4773 42.75 9.74234 36 9.08984"
                                            stroke="black" stroke-width="2" stroke-miterlimit="10"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                    <div class="cv-upload-title">Browse Your Files</div>
                                    <div class="cv-upload-info">You can only upload file with PDF formats and also file
                                        maximum size 10MB.</div>
                                </div>
                                <div class="selected-cv" v-if="selectedCv">
                                    <p>Selected CV</p>
                                    <div class="selected-cv-item">
                                        <div class="cv-icon">
                                            <img src="@/assets/img/default_pdf.svg" alt="" />
                                        </div>
                                        <div class="cv-title">
                                            {{ selectedCv.userFriendlyName }}
                                        </div>
                                        <div class="cv-checked">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M9.99984 1.6665C5.40817 1.6665 1.6665 5.40817 1.6665 9.99984C1.6665 14.5915 5.40817 18.3332 9.99984 18.3332C14.5915 18.3332 18.3332 14.5915 18.3332 9.99984C18.3332 5.40817 14.5915 1.6665 9.99984 1.6665ZM13.9832 8.08317L9.25817 12.8082C9.1415 12.9248 8.98317 12.9915 8.8165 12.9915C8.64984 12.9915 8.4915 12.9248 8.37484 12.8082L6.0165 10.4498C5.77484 10.2082 5.77484 9.80817 6.0165 9.5665C6.25817 9.32484 6.65817 9.32484 6.89984 9.5665L8.8165 11.4832L13.0998 7.19984C13.3415 6.95817 13.7415 6.95817 13.9832 7.19984C14.2248 7.4415 14.2248 7.83317 13.9832 8.08317Z"
                                                    fill="rgb(var(--locumate-secondary-color))" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <p>CV is not selected</p>
                                    <div class="selected-cv-item">
                                        <div class="cv-icon">
                                            <img src="@/assets/img/default_pdf.svg" alt="" />
                                        </div>
                                        <div class="cv-title">
                                            Please upload your CV first
                                        </div>
                                        <div class="cv-crossed">
                                            <i class="el-icon-warning"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="apply-btn">
                        <el-button v-if="isJobApplied" class="submit applied-ok"
                            data-testid="directions-91">Applied</el-button>
                        <el-button v-else class="submit" :disabled="selectedCv === null || v$.questions.$invalid"
                            type="blue" data-testid="directions-88" @click="handleJobPostApplySubmit">Apply
                            Now</el-button>
                    </div>
                </div>
            </div>


            <div class="bg-overlay"></div>
        </div>
        <div v-else><job-listing-skeleton :skeletonCount="1" /></div>


        <el-drawer title="Select CV" custom-class="bottom_drop_up" popper-class="bottom-drawer" v-model="dialogVisible"
            :append-to-body="true" :direction="'btt'" :destroy-on-close="true">

            <div class="cv-upload">
                <div class="cv-upload-title">Browse Your Files</div>

                <div class="cv-upload-info">Support Format : PDF | Maximum 10 MB </div>
                <el-upload class="upload-demo" :headers="headers" :action="CV_UPLOAD_BASE_URL"
                    :on-success="handleSuccess" :before-upload="beforeUpload" drag>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 1.6665V6.6665L11.6667 4.99984" stroke="white" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0002 6.66667L8.3335 5" stroke="white" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M5.83333 10C2.5 10 2.5 11.4917 2.5 13.3333V14.1667C2.5 16.4667 2.5 18.3333 6.66667 18.3333H13.3333C16.6667 18.3333 17.5 16.4667 17.5 14.1667V13.3333C17.5 11.4917 17.5 10 14.1667 10C13.3333 10 13.1 10.175 12.6667 10.5L11.8167 11.4C10.8333 12.45 9.16667 12.45 8.175 11.4L7.33333 10.5C6.9 10.175 6.66667 10 5.83333 10Z"
                            stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M4.1665 10V6.6667C4.1665 4.9917 4.1665 3.60837 6.6665 3.3667" stroke="white"
                            stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M15.8335 10V6.6667C15.8335 4.9917 15.8335 3.60837 13.3335 3.3667" stroke="white"
                            stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <div class="el-upload__text">
                        Upload File
                    </div>
                </el-upload>
            </div>


            <div class="file-lists">
                <div v-for="cv in existingCvs" :key="cv.id">
                    <div class="el-upload-list selectable" @click.prevent="openCvModal(cv)">
                        <div class="el-upload-list__item">
                            <div class="thumbnail_img el-upload-list--picture-card">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <rect width="32" height="32" fill="url(#pattern0_2575_7976)" />
                                    <defs>
                                        <pattern id="pattern0_2575_7976" patternContentUnits="objectBoundingBox"
                                            width="1" height="1">
                                            <use xlink:href="#image0_2575_7976" transform="scale(0.00195312)" />
                                        </pattern>
                                        <image id="image0_2575_7976" width="512" height="512"
                                            xlink:href="data:image/png;base64,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" />
                                    </defs>
                                </svg>

                            </div>
                            <div class="upload-text" :class="{ 'selectedcv': selectedCv && selectedCv.id === cv.id }">
                                <a href="#">
                                    {{ cv.userFriendlyName }}
                                </a>
                                <el-dialog title="CV Preview" v-model="modalVisibleCv" width="50%"
                                    :close-on-click-modal="true" @close="closeCvModal">
                                    <vue-pdf-embed :source="selectedCv.url" />

                                </el-dialog>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <el-button class="submit" type="blue" data-testid="directions-91" @click="handleConfirm"
                :disabled="!existingCvs.length">
                Apply
            </el-button>
        </el-drawer>

        <div class="el_dialog_wraper">
            <el-drawer :direction="'btt'" class="success-prompt" custom-class="success-prompt" :destroy-on-close="true"
                :append-to-body="true" v-model="showJobApplicationPopupMessage" title="Application Submitted"
                width="30%" @closed="showJobApplicationPopupMessage = false">
                <div class="message text-center mt-3">

                    <div class="col-right">
                        <svg width="150" height="150" viewBox="0 0 309 309" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="154.5" cy="154.5" r="153.25" stroke="#009F98" stroke-width="1.5"
                                stroke-dasharray="3 5" />
                            <circle cx="154.5" cy="154.5" r="137.5" fill="white" />
                            <path
                                d="M223.733 140.046L217.067 134.952C217.933 131.869 218.667 129.256 219.333 126.977C222 117.996 223.467 113.037 219.8 107.944C216.133 102.85 211.133 102.649 201.667 102.381H193.4C192.267 99.4321 191.4 96.8184 190.6 94.6067C187.533 85.7603 185.8 81.203 179.8 78.9243C173.8 76.6457 169.6 79.8626 161.867 85.2241L155.2 89.8484L148.533 85.3581C141.667 79.9296 136.6 76.5787 130.533 78.5892C124.467 80.5998 122.867 85.2911 119.733 94.2046C118.933 96.4163 118 99.03 116.933 102.046L108.333 102.314C99 102.314 93.8667 102.649 90.2 107.742C86.5333 112.836 88.3333 117.795 90.8667 126.843C91.5333 129.121 92.3333 131.735 93.1333 134.818L86.4667 139.912C79.2 145.541 75 148.691 75 155.058C75 161.425 79.0667 164.507 86.4667 170.204L93.1333 175.298C92.3333 178.38 91.5333 180.994 90.8667 183.273C88.2 192.253 86.7333 197.213 90.4 202.306C94.0667 207.4 99.2667 207.534 108.533 207.802H116.733C117.867 210.751 118.733 213.364 119.533 215.576C122.667 224.422 124.333 228.98 130.333 231.258C136.333 233.537 140.533 230.32 148.267 224.959L154.933 220.334L161.6 224.824C165.712 228.443 170.787 230.772 176.2 231.526C177.402 231.514 178.595 231.31 179.733 230.923C185.733 228.98 187.4 224.221 190.533 215.308C191.333 213.096 192.2 210.482 193.333 207.534H201.6C210.933 207.534 216.067 207.199 219.733 202.038C223.4 196.878 222 191.985 219.333 183.005C218.667 180.726 217.867 178.112 217.067 175.029L223.733 169.936C231.067 164.641 235 161.76 235 155.058C235 148.356 231.067 145.742 223.733 140.046Z"
                                fill="#009F98" />
                            <path
                                d="M144.133 190.309C143.232 190.271 142.348 190.05 141.534 189.658C140.721 189.266 139.994 188.713 139.4 188.031L119.733 165.981C118.557 164.648 117.957 162.9 118.063 161.122C118.169 159.343 118.974 157.68 120.3 156.498C121.626 155.316 123.365 154.712 125.134 154.819C126.903 154.926 128.557 155.735 129.733 157.068L144.533 173.89L186.733 132.606C187.341 131.914 188.085 131.356 188.917 130.967C189.749 130.578 190.653 130.366 191.571 130.344C192.488 130.322 193.401 130.491 194.251 130.84C195.101 131.189 195.87 131.711 196.509 132.372C197.149 133.034 197.646 133.822 197.969 134.686C198.292 135.55 198.434 136.471 198.387 137.393C198.339 138.315 198.102 139.216 197.691 140.042C197.281 140.867 196.705 141.599 196 142.19L148.8 188.567C147.526 189.732 145.854 190.356 144.133 190.309Z"
                                fill="white" />
                        </svg>
                    </div>
                    <div class="col-right">
                        <p class="header">Congratulations!</p>

                    </div>
                    <div class="col-right">
                        <p>Your job application to <strong>{{ job.pharmacy.name }}</strong> has been successfully sent.
                            Thank you for applying!</p>

                    </div>
                </div>

                <span class="dialog-footer w-100">
                    <el-button @click="showJobApplicationPopupMessage = false" type="primary">Close</el-button>
                </span>
            </el-drawer>
        </div>




    </div>
    <modal-user-application-info :modalName="'userApplicationInfoModal'"
        :options="userApplicationInfoModal"></modal-user-application-info>
    <modal-user-info :modalName="'userInfoModal'" :options="userInfoModal"></modal-user-info>

    <el-drawer title="Add wishlist" custom-class="add-wishlist" v-model="modalVisible" :append-to-body="true"
        :direction="'btt'" :destroy-on-close="true" @close="closeWishlistModal">
        <div class="grid-container" v-if="wishLists.length > 0">
            <div class="grid-item" v-for="(item, index) in wishLists" :key="index" @click="toggleHeart(index, item)"
                :style="{ borderColor: getRandomColor(item.title) }">

                <div class="initial-avatar" :style="{ backgroundColor: getRandomColor(item.title) }">
                    {{ item.title.substring(0, 1).toUpperCase() }}
                </div>
                <div class="item-detail">
                    <div class="grid-title">{{ item.title }}</div>
                    <div class="grid-saved">{{ item.saved }} saved</div>
                    <!-- <div class="favorite rounded-action selected" v-if="showHeart[index]"> -->
                </div>
                <div class="favorite rounded-action selected" v-if="showHeart[index]">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="#FFB800" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.0166 1.6665H5.98327C4.20827 1.6665 2.7666 3.1165 2.7666 4.88317V16.6248C2.7666 18.1248 3.8416 18.7582 5.15827 18.0332L9.22493 15.7748C9.65827 15.5332 10.3583 15.5332 10.7833 15.7748L14.8499 18.0332C16.1666 18.7665 17.2416 18.1332 17.2416 16.6248V4.88317C17.2333 3.1165 15.7916 1.6665 14.0166 1.6665ZM12.0833 9.49984H7.9166C7.57494 9.49984 7.2916 9.2165 7.2916 8.87484C7.2916 8.53317 7.57494 8.24984 7.9166 8.24984H12.0833C12.4249 8.24984 12.7083 8.53317 12.7083 8.87484C12.7083 9.2165 12.4249 9.49984 12.0833 9.49984Z"
                            fill="#FFB800" />
                    </svg>
                </div>
            </div>
        </div>
        <div v-else class="empty-wishlist">Create your first wishlist</div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="createNewWishlist">Create a new wishlist</el-button>
            <el-button class="secondary" @click="closeWishlistModal">Skip adding to wishlist</el-button>
        </div>
    </el-drawer>

    <el-drawer title="Create wishlist" v-model="modalCreateVisible" :close-on-click-modal="true"
        :destroy-on-close="true" @close="closeCreateWishlistModal" :append-to-body="true" :direction="'btt'">
        <el-form :model="form">

            <el-form-item :error="w$.title.$error" :show-message="false" class="no-scroll create-wishlist"
                label="Wishlist Name" :required="true" prop="title">
                <el-input v-model="form.title" placeholder="Enter wishlist name"
                    @input="validateField('title')"></el-input>
                <span class="character-count" v-if="form.title.length < 50">{{ form.title.length }}/50
                    characters</span>
                <el-form-item-error v-if="w$.title.$error">{{ w$.title.$errors[0].$message
                    }}</el-form-item-error>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer create-wl-footer">
            <el-button type="primary" @click="addToWishlist" :disabled="isSubmitDisabled">Create</el-button>
            <el-button class="secondary" @click="clearInput">Clear</el-button>
        </span>
    </el-drawer>
</template>

<script>
import {
    useRouter, useRoute
} from "vue-router";
import { onMounted, inject, ref, onBeforeMount, computed, reactive } from 'vue';
import { addIcons } from 'ionicons';
import { arrowBackOutline } from 'ionicons/icons';
import { ElMessage, ElMessageBox } from "@/components/Vendor/Element";
addIcons({
    'arrow-back-outline': arrowBackOutline,
});
import { IonToolbar, IonButton, } from '@ionic/vue';
import VuePdfEmbed from 'vue-pdf-embed';
import JobListingSkeleton from "@/components/JobListingSkeleton/JobListingSkeleton.vue";
import { PharmacyInfoModal } from "@/modals/modals";
import { useStore } from "vuex";
import { useVuelidate } from '@vuelidate/core';
import { required, maxLength, helpers } from '@vuelidate/validators';
import FileHelpers from "@/helpers/file/file";
import { isUSRegion } from '@/helpers/region/regionHelper.js';
import { trackEvent } from '@/helpers/analytics/ga.js';




export default {
    components: {
        IonToolbar,
        IonButton,
        VuePdfEmbed,
        JobListingSkeleton,
        "modal-user-application-info": PharmacyInfoModal,
        "modal-user-info": PharmacyInfoModal,
    },
    setup() {
        const $router = useRouter();
        const $route = useRoute();
        const $modals = inject("$modals");
        const setPageClassGlobal = inject('setPageClassGlobal');
        const dialogVisible = ref(false);
        const showJobApplicationPopupMessage = ref(true);
        const cvShareReminderDiag = ref(false);
        const reminderPopupShown = ref(false);
        const selectedOption = ref(null);
        const pdfSource = 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf';
        const $store = useStore();
        const token = $store.getters.GET_TOKEN;
        const existingCvs = ref([]);
        const selectedCv = ref(null);
        const isJobApplied = ref(false);
        const initialLoading = ref(false);
        const jobUnavailable = ref(false);
        const fileHelpers = new FileHelpers();
        const selectedJobID = ref(null);
        const showHeart = ref([]);
        const isUS = isUSRegion();

        const modalCreateVisible = ref(false);
        const form = reactive({
            title: ''
        });
        const state = reactive({
            isTruncated: true
        });

        const currentUrl = process.env.VUE_APP_CURRENT_URL;
        const showShareOptions = ref(false)
        const shareText = ref('');
        const shareUrl = ref('');
        const userInfoModal = ref({
            name: "userInfo",
            user: {},
        });

        const icons = {
            email: `<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none"><path d="M4 7.00005L10.2 11.65C11.2667 12.45 12.7333 12.45 13.8 11.65L20 7" stroke="#00000095" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><rect x="3" y="5" width="18" height="14" rx="2" stroke="#00000095" stroke-width="2" stroke-linecap="round"/></svg>`,
            facebook: `<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 6C2 3.79086 3.79086 2 6 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6ZM6 4C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H12V13H11C10.4477 13 10 12.5523 10 12C10 11.4477 10.4477 11 11 11H12V9.5C12 7.567 13.567 6 15.5 6H16.1C16.6523 6 17.1 6.44772 17.1 7C17.1 7.55228 16.6523 8 16.1 8H15.5C14.6716 8 14 8.67157 14 9.5V11H16.1C16.6523 11 17.1 11.4477 17.1 12C17.1 12.5523 16.6523 13 16.1 13H14V20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6Z" fill="#00000095"/></svg>`,
            twitter: `<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.7828 3.91825C20.1313 3.83565 20.3743 3.75444 20.5734 3.66915C20.8524 3.54961 21.0837 3.40641 21.4492 3.16524C21.7563 2.96255 22.1499 2.9449 22.4739 3.11928C22.7979 3.29366 23 3.6319 23 3.99986C23 5.08079 22.8653 5.96673 22.5535 6.7464C22.2911 7.40221 21.9225 7.93487 21.4816 8.41968C21.2954 11.7828 20.3219 14.4239 18.8336 16.4248C17.291 18.4987 15.2386 19.8268 13.0751 20.5706C10.9179 21.3121 8.63863 21.4778 6.5967 21.2267C4.56816 20.9773 2.69304 20.3057 1.38605 19.2892C1.02813 19.0108 0.902313 18.5264 1.07951 18.109C1.25671 17.6916 1.69256 17.4457 2.14144 17.5099C3.42741 17.6936 4.6653 17.4012 5.6832 16.9832C5.48282 16.8742 5.29389 16.7562 5.11828 16.6346C4.19075 15.9925 3.4424 15.1208 3.10557 14.4471C2.96618 14.1684 2.96474 13.8405 3.10168 13.5606C3.17232 13.4161 3.27562 13.293 3.40104 13.1991C2.04677 12.0814 1.49999 10.5355 1.49999 9.49986C1.49999 9.19192 1.64187 8.90115 1.88459 8.71165C1.98665 8.63197 2.10175 8.57392 2.22308 8.53896C2.12174 8.24222 2.0431 7.94241 1.98316 7.65216C1.71739 6.3653 1.74098 4.91284 2.02985 3.75733C2.1287 3.36191 2.45764 3.06606 2.86129 3.00952C3.26493 2.95299 3.6625 3.14709 3.86618 3.50014C4.94369 5.36782 6.93116 6.50943 8.78086 7.18568C9.6505 7.50362 10.4559 7.70622 11.0596 7.83078C11.1899 6.61019 11.5307 5.6036 12.0538 4.80411C12.7439 3.74932 13.7064 3.12525 14.74 2.84698C16.5227 2.36708 18.5008 2.91382 19.7828 3.91825ZM10.7484 9.80845C10.0633 9.67087 9.12171 9.43976 8.09412 9.06408C6.7369 8.56789 5.16088 7.79418 3.84072 6.59571C3.86435 6.81625 3.89789 7.03492 3.94183 7.24766C4.16308 8.31899 4.5742 8.91899 4.94721 9.10549C5.40342 9.3336 5.61484 9.8685 5.43787 10.3469C5.19827 10.9946 4.56809 11.0477 3.99551 10.9046C4.45603 11.595 5.28377 12.2834 6.66439 12.5135C7.14057 12.5929 7.49208 13.0011 7.49986 13.4838C7.50765 13.9665 7.16949 14.3858 6.69611 14.4805L5.82565 14.6546C5.95881 14.7703 6.103 14.8838 6.2567 14.9902C6.95362 15.4727 7.65336 15.6808 8.25746 15.5298C8.70991 15.4167 9.18047 15.6313 9.39163 16.0472C9.60278 16.463 9.49846 16.9696 9.14018 17.2681C8.49626 17.8041 7.74425 18.2342 6.99057 18.5911C6.63675 18.7587 6.24134 18.9241 5.8119 19.0697C6.14218 19.1402 6.48586 19.198 6.84078 19.2417C8.61136 19.4594 10.5821 19.3126 12.4249 18.6792C14.2614 18.0479 15.9589 16.9385 17.2289 15.2312C18.497 13.5262 19.382 11.1667 19.5007 7.96291C19.51 7.71067 19.6144 7.47129 19.7929 7.29281C20.2425 6.84316 20.6141 6.32777 20.7969 5.7143C20.477 5.81403 20.1168 5.90035 19.6878 5.98237C19.3623 6.04459 19.0272 5.94156 18.7929 5.70727C18.0284 4.94274 16.5164 4.43998 15.2599 4.77822C14.6686 4.93741 14.1311 5.28203 13.7274 5.89906C13.3153 6.52904 13 7.51045 13 8.9999C13 9.28288 12.8801 9.5526 12.6701 9.74221C12.1721 10.1917 11.334 9.92603 10.7484 9.80845Z" fill="#00000095"/></svg>`, // ← insert full Twitter SVG
            linkedin: `<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none"><path d="M6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.67157 7.32843 5 6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8Z" fill="#0F0F0F"/><path d="M5 10C5 9.44772 5.44772 9 6 9H7C7.55228 9 8 9.44771 8 10V18C8 18.5523 7.55228 19 7 19H6C5.44772 19 5 18.5523 5 18V10Z" fill="#0F0F0F"/><path d="M11 19H12C12.5523 19 13 18.5523 13 18V13.5C13 12 16 11 16 13V18.0004C16 18.5527 16.4477 19 17 19H18C18.5523 19 19 18.5523 19 18V12C19 10 17.5 9 15.5 9C13.5 9 13 10.5 13 10.5V10C13 9.44771 12.5523 9 12 9H11C10.4477 9 10 9.44772 10 10V18C10 18.5523 10.4477 19 11 19Z" fill="#0F0F0F"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20 1C21.6569 1 23 2.34315 23 4V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4C1 2.34315 2.34315 1 4 1H20ZM20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20Z" fill="#00000095"/></svg>`, // ← insert full LinkedIn SVG
        }

        const wishLists = ref([
        ]);

        const rulesWishList = computed(() => {
            return {
                title: {
                    required: helpers.withMessage('Please enter the wishlist name', required),
                    maxLength: maxLength(50)
                }
            };
        });
        const w$ = useVuelidate(rulesWishList, form);

        const validateField = (fieldName) => {
            // Trigger validation for the specified field
            w$.value[fieldName].$touch();
        };


        const CV_UPLOAD_BASE_URL = process.env.VUE_APP_BASEURL + "/job-seeker/file/ajaxCvUpload";
        console.log(CV_UPLOAD_BASE_URL);
        const headers = {
            'Authorization': "Bearer " + token
        };

        const userApplicationInfoModal = ref({
            name: "userInfo",
            user: {},
        });
        const userApplicationsInfoModalOpen = (user) => {
            if (user) {
                userApplicationInfoModal.value.user = user;
            }
            $modals.open("userApplicationInfoModal");
        };
        const job = ref();

        const toggleView = () => {
            state.isTruncated = !state.isTruncated;
        };

        const jobQuestions = ref();
        console.log("🚀 ~ setup ~ questions:", jobQuestions)
        // const questions = ref({});
        const jobId = computed(() => $route.params.jobId);
        const goBack = () => {

            $router.push({
                name: "job_seeker_index",
            });

        };

        const formData = reactive({
            job_post_id: null,
            cv_id: null,
            questions: {}
        });

        const rules = computed(() => {
            const dynamicRules = {};

            // Apply required validation to each dynamically generated question
            for (const questionId in formData.questions) {
                dynamicRules[questionId] = { answer: { required: helpers.withMessage('Response required. Mandatory field', required) } };
            }

            return {
                questions: dynamicRules
            };
        });

        const v$ = useVuelidate(rules, formData);


        // const v$ = useVuelidate(validationRules, formData);

        const getClass = (status) => {
            // Convert the status to lowercase for case-insensitive comparison
            const lowercaseStatus = status.toLowerCase();

            // Return class based on status
            return lowercaseStatus;
        };

        const openCvDialog = () => {
            dialogVisible.value = true;
        };

        const handleClose = () => {
            dialogVisible.value = false;
        };

        const handleConfirm = () => {
            // Handle confirmation logic
            console.log('Selected option:', selectedOption.value);
            dialogVisible.value = false;
        };

        const handleSuccess = (response, file, fileList) => {
            console.log("🚀 ~ handleSuccess ~ fileList:", fileList)
            console.log("🚀 ~ handleSuccess ~ file:", file)
            console.log("🚀 ~ handleSuccess ~ response:", response)
            // Handle successful upload
            ElMessage.success('Upload success');
            getExistingCvs();

        };



        const beforeUpload = (file) => {
            const isPDF = file.type === 'application/pdf';
            const isLte10M = file.size <= 10 * 1024 * 1024; // 10MB in bytes
            if (!isPDF) {
                // If the file is not a PDF, display an error message
                // You may need to import 'ElMessage' from 'element-plus' or 'element-ui' depending on your setup
                ElMessage.error('Please upload PDF files only.');
            }
            if (!isLte10M) {
                ElMessage.error('File size must be less than 10MB!');
                return false;
            }
            return true;
        };

        const modalVisibleCv = ref(false);
        const modalVisible = ref(false);

        const openCvModal = (cv) => {
            // Set the file URL to be displayed in the modal
            selectedCv.value = cv;
            // Show the modal
            modalVisibleCv.value = true;
        };

        const closeCvModal = () => {
            modalVisibleCv.value = false;
        };

        const userInfoModalOpen = (user) => {
            if (user) {
                userInfoModal.value.user = user;
            }
            $modals.open("userInfoModal");
        };

        const getExistingCvs = () => {
            // Dispatch second action
            (async () => {
                const existingCvResponse = await $store.dispatch("GET_JOB_SEEKER_EXISTING_CV");
                existingCvs.value = existingCvResponse.data;

                //select the Last CV    
                if (existingCvs.value.length > 0) {
                    selectedCv.value = existingCvs.value[existingCvs.value.length - 1];

                    // console.log('selectedCv:', selectedCv.value, existingCvs.value.length);
                }
            })();
        }


        const openReminderToUpdateProfileOrApply = () => {
            if (selectedCv.value === null) {
                selectedOption.value = "option1"
            } else {
                selectedOption.value = "option2"
            }
            if (reminderPopupShown.value === true) {
                handleJobPostApplySubmit();
                return;
            }
            cvShareReminderDiag.value = true;
            reminderPopupShown.value = true;
        };

        // const handleCheckToApply = async () =>{
        //     if(jobQuestions.value.length > 0){
        //         showDialog.value = true; 
        //     }else{
        //         handleJobPostApplySubmit();
        //     }
        // }

        const handleJobPostApplySubmit = async () => {

            cvShareReminderDiag.value = false;
            reminderPopupShown.value = false;
            try {
                await ElMessageBox.confirm(
                    `Your profile will be shared with the employer. To increase your chances of being selected, please make sure your profile is up to date. Click 'Apply' to submit your application. `,
                    "Apply Now",
                    {
                        confirmButtonText: "Apply",
                        cancelButtonText: "Cancel",
                        confirmButtonClass: "el-button--primary",
                        cancelButtonClass: "secondary",
                        showClose: false,
                    }
                );

                await (async () => {
                    try {

                        const formDataNext = new FormData();

                        // Append job_post_id and cv_id
                        formDataNext.append('job_post_id', jobId.value);
                        formDataNext.append('cv_id', selectedCv.value.id);

                        // Append each question and its answer
                        for (const questionId in formData.questions) {
                            const answer = formData.questions[questionId].answer;
                            console.log("🚀 ~ await ~ answer111:", answer)
                            if (Array.isArray(answer)) {
                                answer.forEach((value, index) => {
                                    if (Object.prototype.hasOwnProperty.call(value, 'raw')) {
                                        const fieldName = `questions[${questionId}][file]`;
                                        formDataNext.append(fieldName, value.raw);
                                    } else {
                                        const fieldName = `questions[${questionId}][answer][${index}]`;
                                        formDataNext.append(fieldName, value);
                                    }

                                });
                            } else {
                                formDataNext.append(`questions[${questionId}][answer]`, answer);
                            }
                        }

                        // Dispatch the action to apply for the job
                        const response = await $store.dispatch("APPLY_JOB_BY_JOBSEEKER", formDataNext);
                        isJobApplied.value = true;

                        // Handle response
                        if (response.success) {
                            ElMessage.success(response.message);
                            showJobApplicationPopupMessage.value = true;
                        } else {
                            ElMessage.info(response.data.message);
                        }


                    } catch (error) {
                        const isJobNotAvailable =
                            error.response?.status === 410 ||
                            error.response?.data?.code === 410 ||
                            error.response?.data?.code === 'JOB_NOT_AVAILABLE' ||
                            error.code === 410 ||
                            error.code === 'JOB_NOT_AVAILABLE';
                        if (isJobNotAvailable) {
                            const message = error.response?.data?.message || (error.response?.status === 410 ? 'The job ad is not available anymore.' : error.message);
                            if (message) {
                                ElMessage.info(message);
                            }
                            $router.push({ name: 'job_seeker_index' });
                            return;
                        }
                        ElMessage({
                            type: "error",
                            message: error.message,
                        });
                        console.log("error submit!!");
                    }
                })();
            } catch (error) {
                console.log(error);
            }

        };

        const closeWishlistModal = () => {
            modalVisible.value = false;
        };

        const cropperMethods = {
            beforeAvatarUpload(file) {
                console.log("🚀 ~ beforeAvatarUpload ~ file:", file)
                const image = URL.createObjectURL(file.raw);
                console.log("🚀 ~ beforeAvatarUpload ~ image:", image)
                // const maxSize = 10 * 1024 * 1024; // 10 MB (adjust as needed)
                // if (file.size > maxSize) {
                //     ElMessage({
                //         type: "error",
                //         message: `File size must be less then 10MB! `,
                //     });

                // }
            },
            handleRemove(selectedValue, file) {
                console.log("Selected value:", selectedValue);
                const questionId = selectedValue.id;
                const question = formData.questions[questionId];

                if (question && Array.isArray(question.answer)) {
                    const fileIndex = question.answer.findIndex(f => f.name === file.name && f.url === file.url);
                    if (fileIndex !== -1) {
                        question.answer.splice(fileIndex, 1);
                    }
                }
            },
            handleChange(selectedValue, file, fileList) {
                console.log("🚀 ~ file:", file)
                console.log("Selected value:", selectedValue.id);
                const type = fileHelpers.getFileType(file);

                if (type == "image" || type == "pdf") {
                    formData.questions[selectedValue.id].answer = fileList;

                } else {
                    fileList.pop();
                    formData.questions[selectedValue.id].answer = null;
                    ElMessage({
                        type: "error",
                        message: `Document must be JPG JPEG PNG JFIF or PDF format!`,
                    });
                }
            },
            handlePreview(selectedValue, file) {
                console.log("🚀 ~ file:", file)
                console.log("Selected value:", selectedValue);
                // Handle preview logic here
            },
            handleExceed(selectedValue, file, files) {
                console.log("🚀 ~ handleExceed ~ files:", files)
                console.log("🚀 ~ handleExceed ~ file:", file)
                console.log("Selected value:", selectedValue);
                ElMessage({
                    type: "error",
                    message: `You can upload 1 document only! `,
                });
            },
        };

        onMounted(() => {
            setPageClassGlobal('global_job_seeker_apply_page');
        });

        onBeforeMount(async () => {
            try {
                // Dispatch first action
                initialLoading.value = true
                const jobPostResponse = await $store.dispatch("JOB_SEEKER_JOB_POST", {
                    jobId: jobId.value,
                    params: {
                        with: "pharmacy,pharmacy.settings,category,type",
                    },
                });
                if (!jobPostResponse?.data) {
                    initialLoading.value = false;
                    ElMessage.info('The job ad is not available anymore.');
                    $router.push({ name: 'job_seeker_index' });
                    return;
                }
                const response = await $store.dispatch("FETECH_SEEKER_WISHLIST");
                wishLists.value = response?.data?.data ?? [];

                job.value = jobPostResponse.data;
                trackEvent('job_detail_viewed', { job_id: job.value.id, job_title: job.value.title, user_type: 'logged_in' });
                console.log("🚀 ~ onBeforeMount ~ job.value:", job.value);
                shareUrl.value = currentUrl + "job-listing/guest/job-details/" + job?.value?.id;
                shareText.value = `${job.value.title}`;
                jobQuestions.value = jobPostResponse.data.questions;
                for (const question of jobQuestions.value) {
                    if (question.type === 'checkbox') {
                        formData.questions[question.id] = { answer: [] };
                    } else {

                        formData.questions[question.id] = { answer: '' };
                    }
                }
                getExistingCvs();
                initialLoading.value = false;
            } catch (error) {
                console.log("🚀 ~ this is a test fail ~ error:", error)
                const isJobNotAvailable =
                    error.response?.status === 410 ||
                    error.response?.data?.code === 410 ||
                    error.response?.data?.code === 'JOB_NOT_AVAILABLE' ||
                    error.code === 410 ||
                    error.code === 'JOB_NOT_AVAILABLE';
                if (isJobNotAvailable) {
                    initialLoading.value = false;
                    const message = error.response?.data?.message || (error.response?.status === 410 ? 'The job ad is not available anymore.' : error.message);
                    if (message) {
                        ElMessage.info(message);
                    }
                    $router.push({ name: 'job_seeker_index' });
                    return;
                }
                initialLoading.value = false;
                console.error("Error occurred:", error);
            }
        });

        const removeJob = async (jobId) => {

            try {
                await ElMessageBox.confirm(
                    `Are you sure you want to remove this job?`,
                    "Remove job",
                    {
                        confirmButtonText: "Remove",
                        cancelButtonText: "Cancel",
                        confirmButtonClass: "el-button--danger",
                        cancelButtonClass: "el-button--grey",
                        showClose: false,
                    }
                );

                await (async () => {
                    try {
                        const response = await $store.dispatch("REMOVE_JOB_FROM_JOB_SEEKER_LIST", { jobId: jobId, });

                        if (response.data.success) {
                            goBack();
                            ElMessage({
                                type: "success",
                                message: response.data.message,
                            });
                        } else {
                            ElMessage({
                                type: "success",
                                message: response.data.message,
                            });
                        }

                    } catch (error) {
                        console.log(error);
                        console.log("Jobs not removed!!");
                    }
                })();
            } catch (error) {
                console.log(error);
            }

        }

        const toggleHeart = async (index, item) => {
            showHeart.value[index] = true;
            await (async () => {
                try {
                    const response = await $store.dispatch("ADD_WISHLIST_FAV", { jobId: selectedJobID.value, wishlistId: item.id });
                    //   emit("job-favorite", selectedJobID, response.data.data);
                    if (response.data.success) {
                        ElMessage({
                            type: "success",
                            message: response.data.message,
                        });
                        wishLists.value = response.data.data;
                        modalVisible.value = false;
                    } else {
                        ElMessage({
                            type: "error",
                            message: response.data.message,
                        });
                    }

                } catch (error) {
                    console.log(error);
                }
            })();


            setTimeout(() => {
                showHeart.value[index] = false;
            }, 1000); // Adjust duration as needed
        };

        const displayedText = computed(() => {
            const original = job.value.description;
            if (state.isTruncated && original && original.split(' ').length > 50) {
                return original.split(' ').slice(0, 50).join(' ') + '...';
            } else {
                return original;
            }
        });

        const isShowMoreJD = computed(() => {
            const jobDescription = job.value.description || '';
            return jobDescription.split(' ').length > 50;
        });

        const markFavorite = async (job) => {
            const belongsToWishLists = wishLists.value.some((wishlist) => {           
           return Array.isArray(wishlist.jobs) && wishlist.jobs.length > 0
            ? wishlist.jobs.some((wishlistJob) => wishlistJob.id === job.id)
            : false; 
      });
            const confirmMessage = job.favorite
                ? `Are you sure you want to remove this job from your favorite list? ${belongsToWishLists ? "<br><p style='color: #F56C6C;'>Please note that this will also remove the job from saved wishlist.</p></br>" : "" }`
                : "Are you sure you want to mark this job as favorite?";

            const confirmButtonText = job.favorite ? "Remove" : "Favorite";
            const confirmButtonTitle = job.favorite ? "Remove from favorite list" : "Favorite this job";
            const confirmButtonClass = job.favorite ? "el-button--danger" : "el-button--success";
            try {
                if (job.favorite) {
                    await ElMessageBox.confirm(
                        confirmMessage,
                        confirmButtonTitle,
                        {
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: confirmButtonText,
                            cancelButtonText: "Cancel",
                            confirmButtonClass: confirmButtonClass,
                            cancelButtonClass: "secondary",
                            showClose: false,
                        }
                    );
                }


                await (async () => {
                    try {
                        const response = await $store.dispatch("TOGGLE_FAVORITE", { jobId: job.id, });
                        console.log("🚀 ~ await ~ responserrrr:", response)
                        // emit("job-favorite", job.id, response.data.data);
                        if (response.data.success) {
                            console.log("🚀 ~ await ~ response.data all:", response.data.data)
                            console.log("🚀 ~ await ~ response.data fav:", response.data.data.favorite)
                            job.favorite = response.data.data.favorite
                            console.log("🚀 ~ await ~ jobaaa:", job)
                            ElMessage({
                                type: "success",
                                message: response.data.message,
                            });
                            if (job.favorite == true) {
                                console.log("tttttttttttttttttttttttttt", job.favorite)
                                selectedJobID.value = job.id;
                                setTimeout(() => {
                                    modalVisible.value = true;
                                }, 800);
                            }
                            const newWishlistFetch = await $store.dispatch("FETECH_SEEKER_WISHLIST");
                            console.log("🚀 ~ await ~ newWishlistFetch:", newWishlistFetch)
                            wishLists.value = newWishlistFetch.data.data;

                        } else {
                            ElMessage({
                                type: "error",
                                message: response.data.message,
                            });
                        }

                    } catch (error) {
                        console.log(error);
                    }
                })();
            } catch (error) {
                console.log(error);
            }
        };
        const createNewWishlist = () => {
            modalCreateVisible.value = true
        }

        const addToWishlist = async () => {
            const result = await v$.value.$validate()

            if (!result) {
                alert('The form has errors')
                return
            } else {

                const response = await $store.dispatch("SAVE_SEEKER_WISHLIST_NAME", form);

                if (response.success) {
                    ElMessage({
                        type: "success",
                        message: response.message,
                    });
                    wishLists.value = response.data;
                    form.title = '';
                    modalCreateVisible.value = false;
                    v$.reset();
                } else {
                    ElMessage({
                        type: "error",
                        message: response.message,
                    });
                }
            }

        };

        function getRandomColor(title) {
            // Convert the title to a hash code
            let hash = 0;
            for (let i = 0; i < title.length; i++) {
                hash = title.charCodeAt(i) + ((hash << 5) - hash);
            }

            // Generate color based on the hash
            let color = '#';
            for (let i = 0; i < 3; i++) {
                // Adjust the generated color to be within the light spectrum
                let value = (hash >> (i * 8)) & 0xFF;
                // Ensure the value is in the range of light colors and not too close to white
                value = 180 + (value % 56); // 180 to 235 range
                color += ('00' + value.toString(16)).slice(-2);
            }

            // Ensure the color is not pure white
            if (color.toUpperCase() === '#FFFFFF') {
                return '#FAFAFA'; // Return a very light gray instead of white
            }

            return color;
        }

        const clearInput = () => {
            form.title = '';
        }


        const share = () => {

            const link = currentUrl + "job-listing/guest/job-details/" + job.value.id;
            const el = document.createElement("textarea");
            el.value = link;
            el.setAttribute("readonly", "");
            el.style.position = "absolute";
            el.style.left = "-9999px";
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
            ElMessageBox.alert("Link to current job copied to clipboard", "Thanks", {
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Close",
                callback: () => {
                    console.log("btn click");
                },
            });
        };

        const toggleShareOptions = () => {
            showShareOptions.value = !showShareOptions.value
        }

        const shareLinks = computed(() => ({
            email: `mailto:?subject=${encodeURIComponent(shareText.value)}&body=${encodeURIComponent(shareUrl.value)}`,
            facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl.value)}`,
            twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText.value)}&url=${encodeURIComponent(shareUrl.value)}`,
            linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(shareUrl.value)}&title=${encodeURIComponent(shareText.value)}`
        }))

        return {
            goBack,
            job,
            dialogVisible,
            showJobApplicationPopupMessage,
            cvShareReminderDiag,
            reminderPopupShown,
            selectedOption,
            openCvDialog,
            handleClose,
            handleConfirm,
            handleSuccess,
            beforeUpload,
            openCvModal,
            closeCvModal,
            modalVisible,
            pdfSource,
            existingCvs,
            jobId,
            getClass,
            CV_UPLOAD_BASE_URL,
            headers,
            selectedCv,
            openReminderToUpdateProfileOrApply,
            getExistingCvs,
            isJobApplied,
            handleJobPostApplySubmit,
            initialLoading,
            jobUnavailable,
            userApplicationInfoModal,
            userApplicationsInfoModalOpen,
            removeJob,
            // questions,
            jobQuestions,
            formData,
            v$,
            cropperMethods,
            displayedText,
            toggleView,
            state,
            markFavorite,
            selectedJobID,
            showHeart,
            toggleHeart,
            wishLists,
            createNewWishlist,
            addToWishlist,
            modalCreateVisible,
            clearInput,
            form,
            validateField,
            w$,
            getRandomColor,
            modalVisibleCv,
            closeWishlistModal,
            userInfoModal,
            userInfoModalOpen,
            isShowMoreJD,
            share,
            currentUrl,
            isUS,
            shareUrl,
            showShareOptions,
            toggleShareOptions,
            shareLinks,
            shareText,
            icons
        };
    },
};
</script>

<style scoped>
.job-detail-toolbar {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
}
.job-detail-toolbar :deep(ion-buttons.toolbar-end-buttons) {
    right: 0;
    left: auto;
}
.job-unavailable-state {
    text-align: center;
    padding: 2rem 1rem;
}
.job-unavailable-message {
    margin-bottom: 1.5rem;
    font-size: 1rem;
    color: var(--ion-text-color, #000);
}
.mr-10 {
    margin-right: 10px;
}
.share-wrapper {
  position: relative;
}
.social-icons {
  position: absolute;
  top: 56px; /* adjust based on toolbar height */
  right: var(--locumate-side-spacing);
  background: white;
  border: 1px solid #ddd;
  padding: 2px;
  border-radius: 8px;
  display: flex;
  gap: 12px;
  z-index: 1000;
}

.share-wrapper {
  position: relative;
}
.social-icons {
  position: absolute;
  top: 56px; /* adjust based on toolbar height */
  right: var(--locumate-side-spacing);
  background: white;
  border: 1px solid #ddd;
  padding: 2px;
  border-radius: 8px;
  display: flex;
  gap: 12px;
  z-index: 1000;
}

body:has(.emulateMode) .social-icons {
  top: 132px; /* adjust based on toolbar height in emulate mode */
}
.social-icons a {
  font-size: 20px;
  color: #555;
  display: inline-block;
  padding: 6px;
  border-radius: 4px;
}
.social-icons a:hover {
  color: #000;
  background: rgb(var(--locumate-clr-bubble-selection));
}

.social-icons a {
  display: inline-flex;
  align-items: center;
}
.social-icons svg {
  width: 20px;
  height: 20px;
}
</style>
